import MapboxDraw from '@mapbox/mapbox-gl-draw';
import { circle } from '@turf/turf';

import type { DrawModeContext } from './types';

const DEFAULT_RADIUS_IN_KM = 2;

type CircleDrawMode = {
  clickAnywhere: (state: any, e: any) => any;
  onDrag?: (state: any, e: any) => void;
  onMouseMove?: (state: any, e: any) => void;
  onMouseUp?: (state: any, e: any) => void;
  onSetup: (opts: any) => any;
  onStop?: (state: any) => void;
  toDisplayFeatures: (state: any, geojson: any, display: (feature: any) => void) => void;
};

const CircleMode: CircleDrawMode = {
  clickAnywhere: () => {
    // do nothing
  },
  onSetup: () => {
    // do nothing
  },
  toDisplayFeatures: () => {
    // do nothing
  }
};

Object.assign(CircleMode, MapboxDraw.modes.draw_polygon);

CircleMode.clickAnywhere = function (state: any, e: any) {
  const ctx = this as unknown as DrawModeContext;
  if (state.currentVertexPosition === 0) {
    state.currentVertexPosition++;
    const center = [e.lngLat.lng, e.lngLat.lat];
    const circleFeature = circle(center, state.initialRadiusInKm);

    if (circleFeature.geometry) {
      state.polygon.incomingCoords(circleFeature.geometry.coordinates);
    } else {
      return;
    }

    state.polygon.properties.center = center;
    state.polygon.properties.radiusInKm = state.initialRadiusInKm;
  }
  return ctx.changeMode(MapboxDraw.constants.modes.SIMPLE_SELECT, { featureIds: [state.polygon.id] });
};

CircleMode.onSetup = function (opts: any) {
  const ctx = this as unknown as DrawModeContext;
  const polygon = ctx.newFeature({
    geometry: {
      coordinates: [[]],
      type: MapboxDraw.constants.geojsonTypes.POLYGON
    },
    properties: {
      center: [],
      isCircle: true
    },
    type: MapboxDraw.constants.geojsonTypes.FEATURE
  });

  ctx.addFeature(polygon);

  ctx.clearSelectedFeatures();
  MapboxDraw.lib.doubleClickZoom.disable(ctx);
  ctx.updateUIClasses({ mouse: MapboxDraw.constants.cursors.ADD });
  ctx.activateUIButton(MapboxDraw.constants.types.POLYGON);
  ctx.setActionableState({
    trash: true
  });

  return {
    currentVertexPosition: 0,
    initialRadiusInKm: opts.initialRadiusInKm || DEFAULT_RADIUS_IN_KM,
    polygon
  };
};

CircleMode.toDisplayFeatures = function (state: any, geojson: any, display: (feature: any) => void) {
  const isActivePolygon = geojson.properties.id === state.polygon.id;
  geojson.properties.active = isActivePolygon
    ? MapboxDraw.constants.activeStates.ACTIVE
    : MapboxDraw.constants.activeStates.INACTIVE;
  display(geojson);
};

export { CircleMode };
